module.exports = "/assets/data/949aba73a5408ba1c27ae7e7c68c9b4a-CF11.data.json";